import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  width: 50%;
  position: absolute;
  left: 50%;
  padding: 25px;
  margin: auto;
  background: var(--menu-color-background);
  border-radius: 35px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.15);
  top: 50%;
  transform: translate(-50%, -50%);

  h1 {
    font-size: 22px;
    margin-bottom: 3px;
    line-height: 28px;
    margin-left: 0px;
  }

  .interview-offer {
    p {
      font-size: 18px;
      line-height: 1.6em;
      font-weight: 500;
      margin-bottom: 12px;
      color: var(--grey-0);
      text-align: center;
    }
  }

  .subheader {
    font-family: "Inter";
    font-style: normal;
    font-weight: 700;
    font-size: 32.2808px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    opacity: 0.5;
    text-align: center;
    margin-top: 24px;
  }

  .headline {
    font-family: "GT Super Text";
    font-style: normal;
    font-weight: 400;
    font-size: 38px;
    line-height: 140%;
    text-align: center;
    padding: 0% 15%;
    margin-bottom: 14px;
  }

  .button-row {
    display: flex;
    margin: auto;
    justify-content: center;
  }

  button {
    padding: 10px 20px !important;
    margin: 0px 10px;
  }
  button.secondary {
    color: var(--primary-cta) !important;
    border: 2px solid var(--primary-cta) !important;
    background: transparent !important;
    &:hover {
      background: transparent;
    }
  }

  p {
    font-size: 14px;
    color: #888;
    font-weight: normal;
  }
  img {
    width: 50vw;
  }

  .select {
    margin: 15px auto;
  }

  textarea {
    width: 100%;
    border: 1.5px solid var(--grey-2);
    outline: 2.5px solid transparent;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 15px;
    font-size: 18px;
    margin: 15px auto;
    border-radius: 8px;
    resize: none;

    &:focus {
      border: 1.5px solid transparent;
      outline: 2.5px solid var(--primary-cta-hover);
    }
  }
`;
